import './skeleton-comments.scss';
import Skeleton from '@mui/material/Skeleton';
import Grid from '@mui/material/Grid';

export const SkeletonComments = () => {

    return (
        <div className='skeleton-comments'>
            <Grid container spacing={2} className='contain-comment'>
                <Grid item xs={1}>
                    <Skeleton variant="circular" width={40} height={40} />
                </Grid>
                <Grid item xs={11}>
                    <Skeleton variant="rectangular" height={20} className='comment'/>
                    <Skeleton variant="rectangular" height={10} className='date'/>
                </Grid>
            </Grid>
            <Grid container spacing={2} className='contain-comment'>
                <Grid item xs={1}>
                    <Skeleton variant="circular" width={40} height={40} />
                </Grid>
                <Grid item xs={11}>
                    <Skeleton variant="rectangular" height={20} className='comment'/>
                    <Skeleton variant="rectangular" height={10} className='date'/>
                </Grid>
            </Grid>
            <Grid container spacing={2} className='contain-comment'>
                <Grid item xs={1}>
                    <Skeleton variant="circular" width={40} height={40} />
                </Grid>
                <Grid item xs={11}>
                    <Skeleton variant="rectangular" height={20} className='comment'/>
                    <Skeleton variant="rectangular" height={10} className='date'/>
                </Grid>
            </Grid>
            <Grid container spacing={2} className='contain-comment'>
                <Grid item xs={1}>
                    <Skeleton variant="circular" width={40} height={40} />
                </Grid>
                <Grid item xs={11}>
                    <Skeleton variant="rectangular" height={20} className='comment'/>
                    <Skeleton variant="rectangular" height={10} className='date'/>
                </Grid>
            </Grid>
            <Grid container spacing={2} className='contain-comment'>
                <Grid item xs={1}>
                    <Skeleton variant="circular" width={40} height={40} />
                </Grid>
                <Grid item xs={11}>
                    <Skeleton variant="rectangular" height={20} className='comment'/>
                    <Skeleton variant="rectangular" height={10} className='date'/>
                </Grid>
            </Grid>
            <Grid container spacing={2} className='contain-comment'>
                <Grid item xs={1}>
                    <Skeleton variant="circular" width={40} height={40} />
                </Grid>
                <Grid item xs={11}>
                    <Skeleton variant="rectangular" height={20} className='comment'/>
                    <Skeleton variant="rectangular" height={10} className='date'/>
                </Grid>
            </Grid>
            <Grid container spacing={2} className='contain-comment'>
                <Grid item xs={1}>
                    <Skeleton variant="circular" width={40} height={40} />
                </Grid>
                <Grid item xs={11}>
                    <Skeleton variant="rectangular" height={20} className='comment'/>
                    <Skeleton variant="rectangular" height={10} className='date'/>
                </Grid>
            </Grid>
        </div >
    );
}